import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { InputBase, useMediaQuery, TextField, MenuItem } from "@material-ui/core";
import SearchIcon from '@material-ui/icons/Search';
import { customTheme } from '../customTheme';
import { useSelector, useDispatch } from "react-redux";

const useStyles = makeStyles({
	search: {
		flex: 1,
		position: 'relative',
		borderRadius: customTheme.shape.roundedBorderRadius,
		backgroundColor: customTheme.palette.background.light,
		height: 44,
		display: 'flex',
		alignItems: "center",
	},
	searchIconContainer: {
		height: '100%',
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: customTheme.palette.grey[400],
	},
	searchIcon: {
		fontSize: 20,
	},
	inputRoot: {
		color: 'inherit',
		width: '70%',
	},
	input: {
		padding: customTheme.spacing(1),
		transition: customTheme.transitions.create('width'),
		width: '100%',
		fontSize: 15,
		color: customTheme.palette.grey[600],
	},
	selectInput: {
        height: 30,
        color: "#6a707e",
    },
    paper: {
        background: "#F5F8FA",
        boxShadow: "none",
        marginTop: 50

    },
	noBorder: {
        border: "none",
    },
});

export default function SearchBar({ searchType, setSearchType, customStyle }) {
	const classes = useStyles();
	const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

	const searchText = useSelector(state => state.searchText);
	const routePath = useSelector(state => state.router.location.pathname);
	const dispatch = useDispatch();

	const [visible, setVisible] = React.useState(false);
	const [searchTypes, setSearchTypes] = React.useState([]);

	const handleChange = React.useCallback((value) => {
		dispatch({
			type: "UPDATE_SEARCH_TEXT",
			payload: {
				searchText: value.toUpperCase(),
			}
		});
	}, [dispatch]);

	React.useEffect(() => {
		handleChange("");
		if (new RegExp(`^/parkings/[0-9]+/show$`).test(routePath)) {
			setVisible(".");
			setSearchTypes([{ value: "license_number", label: "License Number" }, { value: "serial_number", label: "Serial Number" }]);
		} else if (routePath === "/monthlyPassLog")
			setVisible("Vehicle Number");
		else if (routePath === "/vehicleDatabase")
			setVisible("License Number");
		else
			setVisible(false);
	}, [routePath]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div className={classes.search} style={{ visibility: visible ? "visible" : "hidden", marginRight: isSmallDevice ? 15 : customTheme.spacing(3), marginLeft: isSmallDevice ? 7 : customTheme.spacing(0), ...customStyle }}>
			<div className={classes.searchIconContainer} style={{ padding: isSmallDevice ? customTheme.spacing(0, 1.7) : customTheme.spacing(0, 4) }}>
				<SearchIcon className={classes.searchIcon} />
			</div>
			<InputBase
				classes={{
					root: classes.inputRoot,
					input: classes.input,
				}}
				value={searchText}
				style={{ marginLeft: isSmallDevice ? 31 : 55 }}
				onChange={(event) => handleChange(event.target.value)}
				placeholder={`Search ${visible}…`}
			/>

			<TextField
                size="small"
                variant='outlined'
                InputProps={{
                    className: classes.selectInput,
                    classes: { notchedOutline: classes.noBorder }
                }}
                InputLabelProps={{ shrink: false }}
                SelectProps={{
                    MenuProps: {
                        PaperProps: {
                            className: classes.paper
                        }
                    }
                }}
                select
                value={searchType}
                onChange={event => setSearchType(event.target.value)}
                className="customSelectStyle"
            >
                {searchTypes.length !== 0 && searchTypes.map(item => {
                    return <MenuItem style={{ color: "#6a707e" }} value={item.value}>{item.label}</MenuItem>;
                })}
            </TextField>
		</div>
	);
}